export default function IconShoppingBag({ className }: { className?: string }) {
    return (
        <svg
            className={className}
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_147_708)">
                <path
                    d="M28.76 11.35C28.6661 11.2402 28.5495 11.1521 28.4183 11.0917C28.2871 11.0313 28.1444 11 28 11H22V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4H13C12.2043 4 11.4413 4.31607 10.8787 4.87868C10.316 5.44129 9.99997 6.20435 9.99997 7V11H3.99997C3.85502 10.9984 3.71144 11.0283 3.57919 11.0876C3.44693 11.147 3.32916 11.2344 3.23404 11.3438C3.13892 11.4531 3.06872 11.5819 3.0283 11.7211C2.98788 11.8603 2.97822 12.0067 2.99997 12.15L4.87997 24.3C4.95229 24.7769 5.19454 25.2116 5.56207 25.524C5.92959 25.8364 6.39764 26.0055 6.87997 26H25.14C25.6223 26.0055 26.0903 25.8364 26.4579 25.524C26.8254 25.2116 27.0676 24.7769 27.14 24.3L29 12.15C29.02 12.0072 29.0089 11.8618 28.9675 11.7237C28.9261 11.5857 28.8553 11.4582 28.76 11.35ZM12 7C12 6.73478 12.1053 6.48043 12.2929 6.29289C12.4804 6.10536 12.7348 6 13 6H19C19.2652 6 19.5195 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V11H12V7ZM25.14 24H6.85997L5.16997 13H26.83L25.14 24Z"
                    fill="currentColor"
                />
            </g>
            <defs>
                <clipPath id="clip0_147_708">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
